// src/portals/fan/pages/NotificationsPage.js
import React, { useState } from 'react';
import PageHeader from '../../components/PageHeader';
import { mockNotifications } from '../../../../data/mockData';
import NotificationItem from './components/NotificationItem';

const NotificationsPage = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [notifications, setNotifications] = useState(mockNotifications);

  const handleMarkAsRead = (id) => {
    setNotifications(notifications.map(n => 
      n.id === id ? { ...n, isRead: true } : n
    ));
  };

  const handleMarkAllAsRead = () => {
    setNotifications(notifications.map(n => ({ ...n, isRead: true })));
  };

  const filteredNotifications = notifications.filter(n => {
    if (activeTab === "all") return true;
    if (activeTab === "mentions") return n.type === "mention" || n.type === "reply";
    if (activeTab === "system") return n.type === "system" || n.type === "subscription";
    return true;
  });

  const tabs = [
    { id: "all", label: "All" },
    { id: "mentions", label: "Mentions" },
    { id: "system", label: "System" },
  ];

  return (
    <div className="flex flex-col h-full bg-slate-50">
      <PageHeader title="Notifications" backTo="/fan/profile" />
      
      <div className="bg-white border-b border-slate-200 px-4">
        <div className="flex space-x-6">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-3 text-sm font-medium border-b-2 transition-colors ${
                activeTab === tab.id
                  ? "border-primary text-primary"
                  : "border-transparent text-slate-500 hover:text-slate-800"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="p-4 flex justify-end">
        <button 
          onClick={handleMarkAllAsRead}
          className="text-xs font-semibold text-primary hover:text-primary-dark"
        >
          Mark all as read
        </button>
      </div>

      <div className="flex-grow overflow-y-auto px-4 pb-4">
        {filteredNotifications.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-slate-500">No notifications found.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {filteredNotifications.map((item) => (
              <div 
                key={item.id} 
                onClick={() => handleMarkAsRead(item.id)}
                className="cursor-pointer transition-opacity hover:opacity-90"
              >
                <NotificationItem notification={item} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationsPage;